import { useEffect, useRef, useState } from 'react';
import { Modal } from '@engie-group/fluid-design-system';
import { NJButton, NJText } from '@engie-group/fluid-design-system-react';
import CenterModal from '@shared/modal/CenterModal';
import { UMSelect } from '../../urbanmap/_components';
import { sameHypotheses } from './hooks';
import type { DevelopmentPlan, Hypotheses } from './types';

const ID = 'plan-unifie-recalculate';
export function RecalculateDialog({ plan, current, onConfirm, onClose }: {
  plan: DevelopmentPlan; current: Hypotheses; onConfirm: (h: Hypotheses) => void; onClose: () => void;
}) {
  const [choice, setChoice] = useState('used');
  const opener = useRef(document.activeElement);
  const differs = !!plan.snapshot && !sameHypotheses(plan.snapshot, current);
  const manualCount = plan.pipes.filter(p => p.manual).length;
  const hide = () => {
    const element = document.getElementById(ID);
    if (element) Modal.getInstance(element)?.hide();
  };
  useEffect(() => {
    const element = document.getElementById(ID);
    if (!element) return;
    Modal.init();
    const instance = Modal.getInstance(element);
    instance.show();
    return () => { instance.dispose(); if (opener.current instanceof HTMLElement) opener.current.focus(); };
  }, []);
  return <CenterModal title="Recalculer le tracé" className="pu-modal-dialog" dataTarget={ID} onHide={onClose} onClick={hide}
    body={<div className="sp-stack">
      {manualCount > 0 && <div className="sp-warning">
        <NJText><strong>{manualCount} canalisation(s) manuelle(s) et leur phasage seront supprimés si le calcul réussit.</strong></NJText>
        <NJText>Annulez pour conserver le plan en l’état. En cas d’échec, le tracé précédent et tous ses phasages restent intacts.</NJText>
      </div>}
      {differs ? <>
        <NJText>Les hypothèses du scénario ont changé depuis le dernier calcul. Choisissez celles à utiliser.</NJText>
        <UMSelect ariaLabel="Hypothèses du recalcul" value={choice} onChange={setChoice} options={[
          { value: 'used', label: 'Hypothèses utilisées lors du dernier calcul' },
          { value: 'current', label: 'Hypothèses actuelles du scénario' },
        ]} />
      </> : <NJText>{plan.snapshot ? 'Les hypothèses du scénario n’ont pas changé.' :
        'Ce plan n’a pas encore été calculé. Les hypothèses actuelles seront utilisées.'}</NJText>}
      <NJText>Les canalisations calculées inchangées conservent leur phasage ; les nouvelles seront à phaser.</NJText>
    </div>}
    footer={<div className="sp-row">
      <NJButton label="Annuler et conserver le plan" emphasis="subtle" onClick={hide} />
      <NJButton label="Confirmer le recalcul" onClick={() => {
        const h = differs && choice === 'used' && plan.snapshot ? plan.snapshot : current;
        hide(); onConfirm(h);
      }} />
    </div>} />;
}
